import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchMyProfile } from '../services/profile';
import { applyBannerProgressFromProfile } from '../utils/questionnaireProgressSync';

/**
 * Refetch questionnaire progress from /profile/me so portal banners show the latest
 * section_progress after saves or when returning from the questionnaire flow.
 */
export default function useRefreshQuestionnaireProgressFromProfile(enabled, refreshKey = '') {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    const refresh = async () => {
      try {
        const profile = await fetchMyProfile();
        if (cancelled) return;
        applyBannerProgressFromProfile(dispatch, profile);
      } catch {
        // non-fatal; Redux may still have value from last save or flow exit flush
      }
    };

    refresh();

    const onFocus = () => {
      if (!cancelled) refresh();
    };
    window.addEventListener('focus', onFocus);

    return () => {
      cancelled = true;
      window.removeEventListener('focus', onFocus);
    };
  }, [dispatch, enabled, refreshKey]);
}
